import getMemoryToken from '../session/token'
import { IDiscoveryResponse } from '../../interfaces/MFE/IDiscoveryAPI';

export default async function fetchMicrofrontsDiscovery (): Promise<IDiscoveryResponse> {

  const sessionToken = await getMemoryToken()

  // LE METO UN TIMEOUT DE 3 SEGUNDOS
  const TIME_OUT = 3000;
  const controller = new AbortController()
  setTimeout(() => controller.abort(), TIME_OUT)
  
  return await fetch(
    `${process.env.MFE_URL_API}/projects/${process.env.PROJECT_ID}/microFrontends`,
    {
      method: 'GET',
      headers: sessionToken !== undefined ? new Headers({ Authorization: `Bearer ${sessionToken}` }) : {},
      credentials: 'include',
      signal: controller.signal
    }
  )
    .then(async resp => await resp.json())
}
